import { render } from "./AchievementItem.vue?vue&type=template&id=4c2d5990"
import script from "./AchievementItem.vue?vue&type=script&lang=js"
export * from "./AchievementItem.vue?vue&type=script&lang=js"

import "./AchievementItem.vue?vue&type=style&index=0&id=4c2d5990&lang=scss"

import exportComponent from "/builds/rahmet/products/grading-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__